import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-xia",
  "use": "icon-xia-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-xia\">\n    <path d=\"M538.112 639.488l379.904-365.568c13.824-13.824 36.352-13.824 50.176 0 13.824 13.824 13.824 35.84 0 49.664L563.2 724.48c-13.824 13.824-36.352 13.824-50.176 0L108.032 323.584c-13.824-13.824-13.824-35.84 0-49.664s36.352-13.824 50.176 0l379.904 365.568z\" p-id=\"11385\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol